import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

function Navbar({ setmovie }) {
  const [text, settext] = useState("");

  const changeText = (e) => {
    settext(e.target.value);
  };

  const getMovie = (e) => {
    e.preventDefault();
    if (text === "") {
      return;
    }
    axios
      .get(`https://www.omdbapi.com/?s=${text}&apikey=12380014`)
      .then((res) => {
        setmovie(res.data.Search);
      });
  };
  return (
    <>
      <nav
        className="navbar navbar-expand-lg  bg-body-tertiary px-5"
        data-bs-theme="dark"
      >
        <div className="container-fluid">
          <Link className="navbar-brand " to="/">
            Movie Search
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link " aria-current="page" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/Favorites">
                  Favorites
                </NavLink>
              </li>
            </ul>
            <form className="d-flex" role="search" onSubmit={getMovie}>
              <input
                className="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
                value={text}
                onChange={changeText}
              />
              <button className="btn btn-outline-light" type="submit">
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
